<template>
  <div class="card">
    <h6>YOUR CURRENT ENERGY SUPPLY</h6>
    <h4 v-if="defaultGasSupplier == quote.supplierId || defaultElectricitySupplier == quote.supplierId">Your {{
      quote.compareFuel === 'gasElectricity' ? 'gas & electricity' : quote.compareFuel }} is currently provided by</h4>
    <h4 v-else>Who is your current {{ quote.compareFuel === 'gasElectricity' ? 'gas & electricity' : quote.compareFuel }}
      supplier?</h4>

    <loader :show="loading.suppliers"></loader>
    <div class="form-group" v-if="!loading.suppliers">
      <div class="col-sm-7">
        <div class="row" v-show="quote.supplierId">
          <div class="col-xs-6 col-md-5">
            <div class="company-logo _margin-top-10 _margin-bottom-20" :class="`supplier-${quote.supplierId}`"></div>
          </div>

          <div class="col-xs-6 col-md-7">
            <uiv-btn class="_margin-top-10" type="link" @click="quote.supplierId = null">
              Change
            </uiv-btn>
          </div>
        </div>

        <div v-show="!quote.supplierId">
          <form-label id="supplier">Select your supplier</form-label>

          <validation-messages label="Supplier" :$v="$v.supplierId">
            <select-list id="supplier" v-model="quote.supplierId" value-key="id" label-key="name" :list="supplierList"
              :error="$v.supplierId.$error" @change="onChooseSupplier" />
          </validation-messages>
        </div>
      </div>
    </div>

    <div v-show="quote.supplierId">
      <loader :show="loading.tariffs"></loader>
      <div class="form-group _margin-bottom-30" v-if="!loading.tariffs">
        <div class="col-sm-7">
          <form-label id="tariff">
            {{ quote.tariff.name ? 'Your tariff' : 'Select your plan' }}
            <button type="button" class="btn-i" v-if="!quote.tariff.name"
              v-uiv-tooltip.right="'You will find what plan you\'re on by looking at your latest bill'">i</button>
          </form-label>
          <validation-messages label="Tariff" :$v="$v.tariff.id">
            <select-list id="tariff" v-model="quote.tariff.id" value-key="id" label-key="name" :list="tariffList"
              :error="$v.tariff.id.$error" @change="onChooseTariff" />
          </validation-messages>
        </div>
      </div>

      <div class="form-group" v-show="quote.tariff.isFixedFromEnergyStartDate">
        <div class="col-sm-7">
          <form-label id="tariffValidToDate">Tariff End Date</form-label>
          <validation-messages label="Tariff End Date" :$v="$v.tariffValidToDate">
            <date-field id="tariffValidToDate" v-model="quote.tariffValidToDate" :error="$v.tariffValidToDate.$error" />
          </validation-messages>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'SupplierTariff',
  props: {
    $v: Object
  },
  data() {
    return {
      requesting: false
    };
  },
  computed: {
    ...mapState({
      isQuoteParamsJourney: ({ session }) => session.quoteParams.isQuoteParamsJourney,
      defaultSupplierId: ({ app_settings }) => app_settings.defaultSupplierId,
      quote: ({ quote }) => quote,
      supplierList: ({ lookups }) => lookups.suppliers,
      tariffList: ({ lookups }) => lookups.tariffs,
      loading: ({ lookups }) => lookups.requesting,
      defaultGasSupplier: ({ quote }) => {
        const address = quote.address.parts;
        if (!address) return false;
        const gasdetails = address.gasdetails.find(({ isDomestic }) => isDomestic) || {};

        return gasdetails.mugSupplierId ? gasdetails.mugSupplierId : false;
      },
      defaultElectricitySupplier: ({ quote }) => {
        const address = quote.address.parts;
        if (!address) return false;
        const elecdetails = address.elecdetails.find(({ isDomestic }) => isDomestic) || {};

        return elecdetails.mugSupplierId ? elecdetails.mugSupplierId : false;
      }
    })
  },
  watch: {
    tariffList(value) {
      const defaultTariffFound = value.find(({ isDefaultOrStandard }) => isDefaultOrStandard);

      if (defaultTariffFound) {
        this.onChooseTariff(defaultTariffFound.id);
      } else if (this.isQuoteParamsJourney == true && value.length > 0) {
        this.onChooseTariff(value[0].id);
      }
    }
  },
  methods: {
    ...mapActions({
      getTariffs: 'lookups/getTariffs'
    }),
    async onChooseSupplier(id) {
      this.quote.tariff = {};
      this.quote.supplierId = id;
      this.quote.tariffValidToDate = null;
      await this.getTariffs({ fuelType: this.quote.compareFuel, supplierId: id });
    },
    onChooseTariff(tariffId) {
      if (!tariffId) return;
      const selected = this.tariffList.find(({ id }) => id == tariffId);
      this.quote.tariff = { ...selected };

      if (!selected.isFixedFromEnergyStartDate) {
        this.quote.tariffValidToDate = null;
      } else if (this.isQuoteParamsJourney == true) {
        this.quote.tariffValidToDate = new Date().toISOString().slice(0, 10);
      }
    }
  }
};
</script>

<style lang="scss"></style>
